import { MY_USER } from '../graphql/queries/UserQueries'

const myUserData = {
  apollo: {
    _user: {
      query: MY_USER,
      update: data => data.myUser,
      result({ data, errors, loading }) {
        if (!loading && !errors) {
          this.$store.dispatch('setUser', data.myUser)
        }
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  data() {
    return { _user: this.$store.getters.user }
  }
}

export default myUserData
